"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TitleIconRoot = exports.SpecialLinkWrapper = exports.ProductsNav = exports.MenuSectionDivider = exports.LinksSpecialLink = exports.LinksRoot = exports.BurgerMenuTopItemLink = exports.BurgerMenuLinkListElement = exports.BurgerMenuLinkLink = exports.BurgerMenuLinkIconWrapper = exports.BurgerMenuLinkCategory = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
var _utils = require("../../../utils");
const ProductsNav = exports.ProductsNav = (0, _mui.styled)('nav')(({
  theme
}) => ({
  overflow: 'scroll',
  [theme.breakpoints.up('md')]: {
    overflow: 'unset'
  }
}));
const LinksRoot = exports.LinksRoot = (0, _mui.styled)('ul')(({
  theme
}) => ({
  color: theme.palette.text.primary,
  display: 'flex',
  flexDirection: 'column',
  fontSize: theme.typography.body1.fontSize,
  fontWeight: theme.typography.fontWeightBold,
  listStyle: 'none',
  margin: theme.spacing(0),
  maxWidth: '100%',
  gap: theme.spacing(3, 0, 3, 0),
  padding: 0,
  width: 315,
  [theme.breakpoints.up('md')]: {
    borderRight: `2px solid ${theme.palette.grey[100]}`,
    fontSize: theme.typography.subtitle1.fontSize,
    margin: 0,
    minHeight: 570,
    width: 280,
    flexShrink: 0,
    '&:first-of-type': {
      marginTop: 'unset',
      paddingTop: theme.spacing(2)
    },
    '&:last-of-type': {
      marginBottom: 'unset',
      paddingBottom: theme.spacing(2)
    }
  }
}));
const SpecialLinkWrapper = exports.SpecialLinkWrapper = (0, _mui.styled)('ul')(({
  theme
}) => ({
  a: {
    '&:hover, &:focus, &:active': {
      background: theme.palette.common.white
    }
  }
}));
const MenuSectionDivider = exports.MenuSectionDivider = (0, _mui.styled)('div')(({
  theme
}) => ({
  marginBottom: theme.spacing(3)
}));
const LinksSpecialLink = exports.LinksSpecialLink = (0, _mui.styled)(_mui.Link)(({
  theme
}) => ({
  color: theme.palette.text.secondary,
  display: 'block',
  fontSize: '1.7rem',
  fontWeight: theme.typography.fontWeightBold,
  lineHeight: 1.9,
  padding: theme.spacing(2, 3, 2, 6),
  textDecoration: 'none',
  background: theme.palette.grey[100],
  '&:hover, &:focus, &:active': {
    color: theme.palette.text.secondary,
    WebkitTapHighlightColor: 'transparent'
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '1.6rem',
    padding: theme.spacing(2, 3, 2, 3)
  }
}));
const BurgerMenuLinkListElement = exports.BurgerMenuLinkListElement = (0, _mui.styled)('li')(({
  theme
}) => ({
  '&:active, &:focus': {
    WebkitTapHighlightColor: 'transparent'
  }
}));
const BurgerMenuLinkLink = exports.BurgerMenuLinkLink = (0, _mui.styled)(_mui.Link)(({
  theme
}) => ({
  color: theme.palette.text.primary,
  flex: 1,
  fontSize: theme.typography.h6.fontSize,
  fontWeight: theme.typography.fontWeightBold,
  lineHeight: '3.7rem',
  margin: 0,
  textDecoration: 'none',
  [theme.breakpoints.up('md')]: {
    fontSize: theme.typography.subtitle1.fontSize
  },
  '&:hover, &:focus, &:active': {
    color: theme.palette.text.primary,
    WebkitTapHighlightColor: 'transparent'
  }
}));

/** Mobile only class */
const BurgerMenuLinkIconWrapper = exports.BurgerMenuLinkIconWrapper = (0, _mui.styled)('span', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  isActiveLink
}) => ({
  alignItems: 'center',
  display: 'flex',
  fontSize: '2.4rem',
  transition: '0.1s ease-in',
  transform: `rotate(${isActiveLink ? 180 : 0}deg)`
}));
const BurgerMenuTopItemLink = exports.BurgerMenuTopItemLink = (0, _mui.styled)(_mui.Link)(({
  theme
}) => ({
  cursor: 'pointer',
  display: 'flex',
  fontSize: theme.typography.h6.fontSize,
  fontWeight: theme.typography.fontWeightBold,
  justifyContent: 'space-between',
  alignItems: 'center',
  lineHeight: '3.2rem',
  margin: 0,
  paddingLeft: theme.spacing(2),
  textDecoration: 'none',
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(2, 3, 2, 3)
  },
  svg: {
    padding: 0
  },
  '&:hover, &:focus, &:active': {
    background: (0, _mui.alpha)(theme.palette.green[50], 0.5),
    color: theme.palette.text.primary,
    svg: {
      color: theme.palette.text.primary
    }
  }
}));
const BurgerMenuLinkCategory = exports.BurgerMenuLinkCategory = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  category,
  isActiveLink,
  theme
}) => {
  const colors = (0, _utils.mapCategoryColors)(theme);
  return {
    color: theme.palette.text.primary,
    cursor: 'pointer',
    display: 'flex',
    fontSize: theme.typography.body1.fontSize,
    fontWeight: theme.typography.fontWeightBold,
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(2, 3),
    textDecoration: 'none',
    background: isActiveLink && category !== undefined ? (0, _mui.alpha)(colors[category], 0.15) : 'inherit',
    margin: 0,
    position: 'relative',
    [theme.breakpoints.up('md')]: {
      fontSize: '2rem',
      padding: theme.spacing(2, 3, 2, 3)
    },
    // Border left with the color of the category had to use before as it's not possible to use border radius on border
    '&:before': {
      content: '""',
      height: '90%',
      width: theme.spacing(1),
      backgroundColor: category === undefined ? 'transparent' : colors[category],
      position: 'absolute',
      left: 0,
      top: 2,
      display: 'block',
      borderRadius: '0 2px 2px 0'
    },
    '&:hover, &:focus, &:active': {
      color: theme.palette.text.primary,
      background: category === undefined ? 'inherit' : (0, _mui.alpha)(colors[category], 0.15)
    },
    span: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  };
});
const TitleIconRoot = exports.TitleIconRoot = (0, _mui.styled)('div')(({
  theme
}) => ({
  fontSize: '1.7rem',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: 260,
  [theme.breakpoints.up('md')]: {
    fontSize: '2rem'
  },
  svg: {
    marginRight: theme.spacing(2),
    display: 'inline-block',
    verticalAlign: 'text-bottom'
  }
}));
